import * as React from 'react';
import classNames from 'classnames';
import {Avatar, Flex, Text} from 'components/UIKit';
import {initials} from '../../../../utilities';
import {BuyerPublic} from '../../../../interfaces/User';
import styles from './UserInfo.scss';

interface UserInfoProps {
  user: BuyerPublic;
  lowlight?: boolean;
  className?: string;
}

export function UserInfo(props: UserInfoProps) {
  const {user, lowlight, className} = props;
  return (
    <Flex alignItems="center" className={classNames(className, lowlight && styles.lowlight)}>
      <Avatar imageSrc={user.avatar} fallback={initials(user.name)} size="small" />
      <div className={styles.userInfo}>
        <Text
          text={user.name}
          className={styles.userName}
          type="small"
          component="p"
          align="left"
          inheritColor
          resetMargin
          ellipsis
        />
        <p className={styles.userEmail}>{user.email}</p>
      </div>
    </Flex>
  );
}
